import React, { ReactNode, useEffect } from 'react'
import ReactModal from 'react-modal'
import Box from './primitives/Box'

// Make sure to bind modal to your appElement (https://reactcommunity.org/react-modal/accessibility/)
ReactModal.setAppElement('#___gatsby')

export const Modal = ({
  children,
  onClose,
  contentMaxWidth,
}: {
  children: ReactNode
  onClose: () => void
  contentMaxWidth?: string
}) => {
  useEffect(() => {
    if (!document?.body) {
      return
    }
    document.body.style.overflow = 'hidden'
    return () => {
      document.body.style.overflow = 'unset'
    }
  }, [])
  return (
    <ReactModal
      isOpen={true}
      onRequestClose={onClose}
      overlayElement={(props, contentElement) => (
        <Box
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          {...(props as any)}
          style={{ inset: 0, backgroundColor: 'rgba(0,0,0,0.9)' }}
          position="fixed"
          display="flex"
          alignItems="center"
          justifyContent="center"
          zIndex={1000}
          paddingX={{ xs: 16, md: 64 }}
          paddingTop={64}
          paddingBottom={20}
        >
          <Box position="absolute" right={24} top={24}>
            <Box.button
              css={`
                all: unset;
                appearance: none;
                cursor: pointer;
                display: block;

                svg {
                  opacity: 0.8;
                }

                &:hover {
                  background: none;

                  svg {
                    opacity: 1;
                  }
                }
              `}
              onClick={onClose}
              aria-label="Close modal"
            >
              <svg
                width="20"
                height="20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M2 2l8 8m8 8l-8-8m0 0l8-8L2 18"
                  stroke="#fff"
                  strokeWidth="3"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </Box.button>
          </Box>
          {contentElement}
        </Box>
      )}
      contentElement={(props, children) => (
        <Box
          {...props}
          style={{}}
          background="transparent"
          width="100%"
          position="relative"
          left={0}
          top={0}
          padding={0}
          overflow="visible"
          border="none"
          // @ts-expect-error -- this works
          maxWidth={contentMaxWidth}
        >
          {children}
        </Box>
      )}
    >
      {children}
    </ReactModal>
  )
}
